  import {inject, Injectable} from '@angular/core';
import {cloneDeep, flatMap, forEach, includes, isEmpty, keys, omit, toLower, uniq} from 'lodash-es';
import {getClonedObject, isDefined} from "@wm/core";
import {BaseComponent} from "@wms/components";
import {EventManagerService} from "@wms/app";
import {BindVariableService} from "@wms/services";

@Injectable({
  providedIn: 'root'
})
export class AppLocaleManagerService extends  BaseComponent{

  showNewLocaleMsgScreen:boolean = false;
  messageSearchKey: string = '';
  deleteList: any = [];
  validationMessage: any;
  addInProgress: boolean = false;
  multipleLocaleExists: boolean = false;
  supportedLocale: any = [];
  activeMessage: any = {};
  activeFormat: any = {};
  selectedTempLocale: any = {};
  supportedLocaleCodesMap: any = {};
  formatsList: any = [];
  userFormats: any = {};
  systemFormats: any = {};
  userMessages: any = {};
  userPrefabMessages: any = {};
  systemMessages: any = {};
  systemMessageKeys: any = {};
  messagesList: any = [];
  newMessage: any = {};
  initUserMessage:any;
  initUserPrefabMessage:any;


  showLocaleAction:boolean = false;
  showNewMsgAction:boolean
  localeCodesMap: any = [];
   messagesModifiedInPrefab: any = {};
   userFiles: any = {};
   systemFiles: any = {};
  projectDetails: any = {};
   projectProps: any = {};
   deletedLocale: any = []
  filteredMessageList: any = [];
   systemFormatKeys: any = {};
   filteredLocaleCodesMap: any = {};
   userFormatKeys: any = {};
   userMessageKeys: any = {};
   projectDefaultLanguage: string;
   userPrefabMessageKeys: any = {};
  selectedPrefab: string = '';
  filteredPrefabMessagesList: any = [];
   prefabMessagesList: any = [];
  thereIsError:boolean ;

   newLocaleAdded: boolean = false;
  private keyRegEx = new RegExp('^[a-zA-Z_][A-Za-z0-9_]+$');
   isDeleteRequired: boolean = false;

  bindVariableService: BindVariableService;

  constructor() {
    super()

    this.bindVariableService = inject(BindVariableService);
  }



  // function for toggling validation message
  toggleMessage(show: any, msg?: any, type?: any) {
    if (show) {
      this.validationMessage = { 'caption': msg || '', type: type };
    } else {
      this.validationMessage = null;
    }
  }

  onInputClick($event: any) {
    $event.stopPropagation();
  }

  //checks if the messages is already in delete state
  isMessageDeleted(messageKey: any) {
    return includes(this.deleteList, messageKey);
  }


  initAppLocaleBundle() {
    if(this.showNewLocaleMsgScreen) {
      import('src/assets/resources/files/localeCodesMap').then(response => {
        this.localeCodesMap = response.localeCodesMap;
      });
    }
    (this.i18nService.getLocaleBundle() as Promise<any>).then(() => {
      this.supportedLocale = getClonedObject(this.i18nService.supportedLocale);
      forEach(this.supportedLocale, (locale: any) => {
        //load locale file
        let localeBundle = getClonedObject(this.i18nService.getAppLocaleBundle(locale));
        if (localeBundle) {
          this.constructModel(locale, localeBundle);
        }
      });

      this.constructKeyMap();
      this.updateFilteredLocaleCodesMap();
      this.toggleMessage(false);
    }).catch((err: any) => {
    });
  }

  // Prepares the messages to display on the UI.
  constructModel(locale: any, bundle: any) {
    if (this.supportedLocale.length) {
      this.systemMessages[locale] = {};
      forEach(bundle.systemMessages, (value: any, key: any) => {
        this.systemMessages[locale][key] = value;
        this.systemMessageKeys[key] = true;
      });
      this.userMessages[locale] = {};
      forEach(bundle.userMessages, (value: any, key: any) => {
        this.userMessages[locale][key] = value || (this.userMessages.en && this.userMessages.en[key]);
        this.userMessageKeys[key] = true;
      });
      this.userPrefabMessages[locale] = {};
      forEach(bundle.userPrefabMessages, (value: any, key: any) => {
        this.userPrefabMessages[locale][key] = value || (this.userPrefabMessages.en && this.userPrefabMessages.en[key]);
        this.userPrefabMessageKeys[key] = true;
      });
      this.systemFormats[locale] = {};
      forEach(bundle.systemFormats, (value: any, key: any) => {
        this.systemFormats[locale][key] = value;
        this.systemFormatKeys[key] = true;
      });
      this.userFormats[locale] = {};
      forEach(bundle.userFormats, (value: any, key: any) => {
        this.userFormats[locale][key] = value;
        this.userFormatKeys[key] = true;
      });
      this.userFiles[locale] = bundle.userFiles;
      this.systemFiles[locale] = bundle.systemFiles;
    }
    this.initUserMessage = cloneDeep(this.userMessages)
    this.initUserPrefabMessage = cloneDeep(this.userPrefabMessages)
  }

  //constructs the key map and prepares the userMessages with the systemMessages
  constructKeyMap() {
    /*maintain a unique set of keys from system and project*/
    this.messagesList = uniq(Object.keys(this.userMessages.en || {}).concat(Object.keys(this.systemMessages.en || {})));
    this.filteredMessageList = cloneDeep(this.messagesList);
    this.formatsList = uniq(Object.keys(this.userFormats.en || {}).concat(Object.keys(this.systemFormats.en || {})));
    /*merge the userMessagesModel with systemMessagesModel*/
    forEach(this.supportedLocale, (locale: any) => {
      forEach(this.systemMessageKeys, (value: any, key: any) => {
        this.userMessages[locale][key] = this.userMessages[locale][key] || this.systemMessages[locale][key];
      });
      forEach(this.systemFormatKeys, (value: any, key: any) => {
        this.userFormats[locale][key] = this.userFormats[locale][key] || this.systemFormats[locale][key];
      });
    });
  }

  updateFilteredLocaleCodesMap = () => {

    this.filteredLocaleCodesMap = omit(this.localeCodesMap, this.supportedLocale);
    this.supportedLocaleCodesMap = {};
    forEach(this.supportedLocale, (locale: any) => {
      if (locale === 'en') {
        return;
      }
      this.supportedLocaleCodesMap[locale] = this.localeCodesMap[locale];
    });
    if (this.supportedLocale.length > 1) {
      this.selectedTempLocale.key = (includes(this.supportedLocale, this.projectDefaultLanguage) && this.projectDefaultLanguage !== 'en') ? this.projectDefaultLanguage : (this.supportedLocale[0] === 'en' ? this.supportedLocale[1] : this.supportedLocale[0]);
      this.tempLocaleChanged();
      this.multipleLocaleExists = true;
    } else {
      this.multipleLocaleExists = false;
    }
  }
  tempLocaleChanged(){
    if(this.selectedPrefab){
      this.getUniquePrefabMessageKeys(this.selectedPrefab);
    }
  }

  //return a unique set of prefabMessage keys
  getUniquePrefabMessageKeys(prefabName: any,locale: any = this.selectedTempLocale.key) {
    this.prefabMessagesList = uniq(Object.keys(this.messagesModifiedInPrefab.en[prefabName] || {}).concat(Object.keys(this.messagesModifiedInPrefab[locale]?.[prefabName] || {})));
    this.filteredPrefabMessagesList = getClonedObject(this.prefabMessagesList);
  }



  save(bindDialogue: boolean): Promise<void> {
    return new Promise((resolve, reject) => {
      let msgContent: any = {},
        prefabMsgContent: any = {},
        formatContent: any = {},
        bundle: any = [],
        invalidMsgKey: any,
        invalidMsgLocale;

      if (this.addInProgress) {
        this.thereIsError = false;
        this.add(this.newMessage);
        if (!bindDialogue || this.thereIsError) {
          if (this.showNewMsgAction && !this.thereIsError) {
            this.showNewMsgAction = false;
          }
          resolve();
          return;
        }
      }

      this.supportedLocale.forEach((locale: any) => {
        msgContent[locale] = {};
        prefabMsgContent[locale] = {};
        formatContent[locale] = {};
      });

      forEach(this.messagesList, (messageKey: any) => {
        if (includes(this.deleteList, messageKey)) {
          return;
        }
        this.supportedLocale.forEach((locale: any) => {
          let userMessage = this.userMessages[locale][messageKey],
            systemMessage = this.systemMessages[locale][messageKey];
          if (userMessage !== systemMessage && userMessage) {
            msgContent[locale][messageKey] = userMessage;
          } else if (!isDefined(this.userMessages[locale][messageKey])) {
            msgContent[locale][messageKey] = this.userMessages.en[messageKey];
          } else if (!userMessage) {
            invalidMsgKey = messageKey;
            invalidMsgLocale = this.localeCodesMap[locale];
            return false;
          }
          return;
        });
        if (invalidMsgKey) {
          return false;
        }
        return;
      });

      this.supportedLocale.forEach((locale: any) => {
        forEach(this.userPrefabMessages[locale], (messages: any, prefabName: any) => {
          forEach(messages, (value: any, messageKey: any) => {
            if (includes(this.deleteList, messageKey)) {
              return;
            }
            let userPrefabMessage = this.userPrefabMessages[locale]?.[prefabName]?.[messageKey],
              systemMessage = this.systemMessages[locale][messageKey],
              messageInPrefabProj = (this.messagesModifiedInPrefab[locale]?.[prefabName]?.[messageKey]) || (this.messagesModifiedInPrefab['en'] && this.messagesModifiedInPrefab['en']?.[prefabName]?.[messageKey]);

            if (userPrefabMessage !== systemMessage && userPrefabMessage != messageInPrefabProj && userPrefabMessage) {
              if (!prefabMsgContent[locale][prefabName]) {
                prefabMsgContent[locale][prefabName] = {};
              }
              prefabMsgContent[locale][prefabName][messageKey] = userPrefabMessage;
            }
          });
        });
      });

      forEach(this.formatsList, (messageKey: any) => {
        this.supportedLocale.forEach((locale: any) => {
          let userFormat = this.userFormats[locale][messageKey],
            systemFormat = this.systemFormats[locale][messageKey];
          formatContent[locale][messageKey] = userFormat || systemFormat;
        });
      });

      if (invalidMsgKey) {
        this.toggleMessage(true, this.locale.LABEL_APP_DEFAULT_MESSAGE_VALUE + ' for ' + invalidMsgKey + ' in ' + invalidMsgLocale + ' language : ' + this.locale.LABEL_APP_MESSAGE_ERROR_EMPTY, 'error');
        reject(new Error('Invalid message key: ' + invalidMsgKey));
        return;
      }

      forEach(Object.keys(msgContent), (localeKey: any) => {
        bundle.push({
          'locale': localeKey,
          'user': {
            'messages': msgContent[localeKey],
            'formats': formatContent[localeKey],
            'files': (isEmpty(this.userFiles[localeKey]) ? this.systemFiles[localeKey] : this.userFiles[localeKey]),
            'prefabMessages': prefabMsgContent[localeKey]
          }
        });
      });

      if (this.isDeleteRequired) {
        (this.removeDeletedLocale(this.deletedLocale) as Promise<any>)
          .then(() => {
            return this.saveAppLocaleBundle(bundle);
          })
          .then(() => resolve())
          .catch((error) => reject(error));
      } else {
        this.saveAppLocaleBundle(bundle)
          .then(() => resolve())
          .catch((error) => reject(error));
      }
    });
  }

  isMessageAlreadyExists(messageKey: any) {
    let _userMessageKeys = flatMap(keys(this.userMessageKeys), toLower),
      _userPrefabMessageKeys = flatMap(keys(this.userPrefabMessageKeys), toLower),
      _systemMessageKeys = flatMap(keys(this.systemMessageKeys), toLower);
    return includes(_userMessageKeys, messageKey) || includes(_systemMessageKeys, messageKey) || includes(_userPrefabMessageKeys, messageKey);
  }

  removeDeletedLocale(locales: any) {
    return new Promise<void>((res, rej) => {
      if (isEmpty(locales)) {
        res();
      }
      (this.i18nService.deleteLocale(locales.join(',')) as Promise<any>).then(() => {
        /*prepare the project details object and update the details as team project expects*/
        let projectDetailsObj = {
          'projectDetails': {
            'displayName': this.projectDetails.displayName,
            'description': this.projectDetails.description || '',
            'version': this.projectDetails.version || '1.0',
            'defaultLanguage': this.projectProps.defaultLanguage,
            'supportedLanguages': this.supportedLocale.join(','),
            'homePage': this.projectProps.homePage,
            'dateFormat': this.projectProps.dateFormat,
            'timeFormat': this.projectProps.timeFormat,
            'icon': this.projectDetails.icon,
            'packagePrefix': this.projectProps.packagePrefix,
            'copyright': this.projectProps.copyrightMsg,
            'skipSwaggerCodeGen': this.projectProps.skipSwaggerCodeGen
          }
        };
        /*Update the project service with the new details of supported locale once they're deleted*/
        res(this.projectService.updateDetails(projectDetailsObj));
      });
    });
  }

  // update supportedLocale app variable
  updateAppVariable() {
    //wms:update-and-save-supportedLocale-variable
    this.eventManager.emitUpdateSupportedVar(this.supportedLocale);
  }

  // saves the appLocaleBundle
  saveAppLocaleBundle(bundle: any): Promise<void> {
    return (this.i18nService.saveAppLocaleBundle(bundle, true) as Promise<any>)
      .then(() => {
        this.i18nService.getLocaleBundle();
        if (this.newLocaleAdded || this.deletedLocale.length) {
          this.newLocaleAdded = false;
          this.updateAppVariable();
        }
        /*if the deleted file is open in the activeWS then just close the WS and reload files tree*/
        forEach(this.deletedLocale, (localeCode: any) => {
          // $rs.$emit('close-ws', 'RESOURCE:../project/i18n/' + localeCode + '.json');
        });
        // $rs.$emit('update-files-tree');
        this.showLocaleAction = false;
        this.closeModal(this.deleteList.length > 0);
      });
  }

  add(message: any) {
    this.toggleMessage(false);
    //make sure the new message to be inserted is valid in the below scenarios
    /*
     * message key cannot be empty
     * message key shouldn't accept specialCharacters
     * message key shouldn't already exist
     * message value must either exist in primary or secondary language
     * */
    if (isEmpty(message) || isEmpty(message.key)) {
      this.toggleMessage(true, this.locale.LABEL_APP_MESSAGE_KEY + ': ' + this.locale.LABEL_APP_MESSAGE_ERROR_EMPTY, 'error');
      this.thereIsError = true;
      return;
    }
    if (!this.keyRegEx.test(message.key)) {
      this.toggleMessage(true, this.locale.LABEL_APP_MESSAGE_KEY + ': ' + this.locale.MESSAGE_INSERT_VARIABLE_PROPERTY_PATTERN, 'error');
      this.thereIsError = true;
      return;
    }
    if (this.isMessageAlreadyExists(message.key.toLocaleLowerCase())) {
      this.toggleMessage(true, this.locale.LABEL_APP_MESSAGE_KEY + ': ' + this.locale.LABEL_ALREADY_EXISTS, 'error');
      this.thereIsError = true;
      return;
    }
    if (!message.en && !message[this.selectedTempLocale.key]) {
      this.toggleMessage(true, this.locale.LABEL_APP_DEFAULT_MESSAGE_VALUE + ': ' + this.locale.LABEL_APP_MESSAGE_ERROR_EMPTY, 'error');
      this.thereIsError = true;
      return;
    }
    this.userMessageKeys[message.key] = true;
    if (this.multipleLocaleExists) {
      this.supportedLocale.forEach((locale: any) => {
        this.userMessages[locale][message.key] = message[locale] || message.en || message[this.selectedTempLocale.key];
      });
    } else {
      this.userMessages.en[message.key] = message.en;
    }
    this.messagesList.unshift(message.key);
    this.filteredMessageList.unshift(message.key);

    if(!this.showNewLocaleMsgScreen){
      this.addInProgress = false;
      this.newMessage = {};
    }

  }

  hideNewField() {
    if(this.showNewLocaleMsgScreen){
      this.showNewLocaleMsgScreen = false;
      this.newMessage = {};
      this.addInProgress=false;
      this.bindVariableService.appMessagesInitialized = false;
    }else {
      this.addInProgress = false;
    }


    this.toggleMessage(false);
  }

  closeModal(changes?: boolean) {
    this.thereIsError = false;
    if (this.addInProgress) {
      this.hideNewField();

      if(this.showNewMsgAction){
        this.showNewMsgAction = false;
        if(isEmpty(this.newMessage)){
          this.showLocaleAction = false;
        }
      }
      return;
    }
    if(changes){
      this.deleteList = [];
      this.activeMessage = {};
      this.activeFormat = {};
      this.toggleMessage(true);
      this.initAppLocaleBundle();

    }
    this.showLocaleAction = false;
    if(this.showNewMsgAction){
      this.showNewMsgAction = false;
    }
    this.eventManager.emitOnModelClose();
  }

  cancle(){
    this.thereIsError = false;
    this.newMessage = {}
  }


}
